<!--  -->
<template>
  <div class>
    <iframe id="mapPage" width="100VW" height="100VH" frameborder=0
    :src="url">
</iframe>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  props:{
      loc: {}
  },
  components: {},
  data() {
    //这里存放数据
    return {
      baseUrl: `https://apis.map.qq.com/tools/locpicker?search=1&type=0`,
      key: "5EEBZ-IG7KG-FJGQJ-IPISD-ESM4H-O6FJ3",
      url:''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getUrl() {
      let coord = "";
      let loc = this.loc;
      if (this.loc&&loc.lat&&loc.lng) {
        coord = `&coord=${loc.lat},${loc.lng}`;
      }
      this.url=`https://apis.map.qq.com/tools/locpicker?search=1&type=1${coord}&key=${this.key}&referer=myapp`
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getUrl()
    this.query = this.$route.query;
    console.log(this.query);

            var self = this
            window.addEventListener('message', function(event) {
                // 对于无法识别的地址，直接返回无法选择
                var loc = event.data
                if (loc.poiname === '我的位置' || loc.poiaddress === '') {
                    self.$toast('无法识别该地址，请移动地图重新选择')
                    return false
                }
                if (loc && loc.module === 'locationPicker') { // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    self.$emit('callback', loc)
                }
            }, false)

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
    #mapPage{
        width: 100VW;
        height: 100VH;
    }
</style>